import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.a`
  display: grid;
  grid-auto-flow: column;
  gap: 12px;
  cursor: pointer;

  &:hover {
    color: ${Colors.B500};
  }
`

export const Name = styled.div`
  font-size: 14px;
  line-height: 1.5;
`

export const Image = styled.img`
  width: 56px;
`
